module.exports = __webpack_public_path__ + "static/media/title8.1d378467.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/进度条/title8.png
// module id = 1638
// module chunks = 0